module.exports = __webpack_public_path__ + "static/media/jo.27900050.svg";